import { IForecaWeatherInfo, IGResponse } from '@common/models';
import IForecast from "@common/models/CMS/Weather";
import Label from "@components/general/Label";
import { getFilePath } from "@config/appConfig";
import { Culture } from "@core/Culture";
import Translate from "@service/Translate";
import { WEATHER, useApolloQuery } from "@service/graphql";
import { FC } from 'react';

interface IWeatherRecentProps {
    dataSource: IForecaWeatherInfo;
    location?: string;
    loadOf?: 'foreca' | 'mahan';
    sunrise?: string;
    sunset?: string
}

export const WeatherRecent: FC<IWeatherRecentProps> = ({ dataSource, location, loadOf, sunrise, sunset }) => {
    const { tr } = Translate;
    const humidity = dataSource.rhum?.toString() + ' %';
    const wind = dataSource.winds + ' km/h';
    const pressure = Math.round(Number(dataSource.pres)).toString() + ' bpa';
    const { data } = useApolloQuery<IGResponse<IForecast[]>>(WEATHER, { variables: { code_in: [dataSource?.symb?.slice(1)] } });

    return (
        <div className="weather-recent">
            {data?.weather ?
                <img
                    className="weather-icon"
                    alt="weather-icon"
                    src={loadOf === "foreca" ?
                        "https://www.foreca.com/public/images/symbols/" + getSweatIcon(data?.weather, dataSource.symb || '').forecastChosen?.icon?.paths[getSweatIcon(data?.weather, dataSource.symb || '').indexOfPath].split('weather/icon/')[1] :
                        getFilePath(getSweatIcon(data?.weather, dataSource.symb || '').forecastChosen?.icon?.paths[getSweatIcon(data?.weather, dataSource.symb || '').indexOfPath])
                    }
                /> : ""
            }
            <article className={`article-weather${location ? "" : " mode-2"}`}>
                <section className='temperature-container'>
                    <h2 className='text temperature'>{dataSource.temp}&deg;c</h2>
                    {location && <h3 className='text description'>{tr('weather_location', location)}</h3>}
                </section>
                <section className='property-weather' style={{ justifyContent: location ? "" : "flex-start" }}>
                    {location &&
                        <Label
                            icon={location ? '' : 'icon-wind-outline'}
                            text={wind}
                            mode='inline'
                        />
                    }
                    {location &&
                        <Label
                            icon='icon-droplets-outline'
                            text={humidity}
                            mode='inline'
                        />
                    }
                    {location &&
                        <Label
                            icon='icon-pressure-outline'
                            text={pressure}
                            mode='inline'
                        />
                    }
                    {!location &&
                        <div className="property-container">
                            <Label
                                icon='icon-sunrise-outline'
                                text={sunrise?.slice(0, 5)!}
                                mode='block'
                            />
                        </div>
                    }
                    {!location &&
                        <div className="property-container">
                            <Label
                                icon='icon-sunset-outline'
                                text={sunset?.slice(0, 5)!}
                                mode='block'
                            />
                        </div>
                    }
                    {!location &&
                        <div className="property-container">
                            <Label
                                icon={location ? '' : 'icon-wind-outline'}
                                text={wind}
                                mode='block'
                            />
                        </div>
                    }
                    {!location &&
                        <div className="property-container desktop">
                            <Label
                                icon='icon-droplets-outline'
                                text={humidity}
                                mode='block'
                            />
                        </div>
                    }
                    {!location &&
                        <div className="property-container desktop">
                            <Label
                                icon='icon-pressure-outline'
                                text={pressure}
                                mode='block'
                            />
                        </div>
                    }
                </section>
            </article>
        </div>
    )
}

export const getSweatIcon = (data: IForecast[], dayState: string): { forecastChosen: IForecast, indexOfPath: number } => {
    const { lang } = Culture.getLocale();
    const stateOfDay: boolean = dayState?.length ? dayState[0] === 'd' : false;
    const langState: boolean = lang === 'fa';
    const forecastChosen: IForecast = langState ? data.find(item => item.name.charCodeAt(0) > 123) as IForecast : data.find(item => item.name.charCodeAt(0) < 123) as IForecast;
    const indexOfPath = forecastChosen?.icon.paths.findIndex(item => item.includes('d'));
    return { forecastChosen, indexOfPath: stateOfDay ? indexOfPath : 1 - indexOfPath }
}